import React, { useState, useEffect } from "react";
import "../styles/components/DashboardFilter.scss";
import NotifyIcon from "img/group-1230.svg";
import NoNotifyIcon from "img/group-179854.svg";
import OverlayPopOverToolTip from "Uitls/OverlayPopOverToolTip";
import { ToolTipText } from "components/TooltipText";
import nextIcon from "img/gileadLogo.svg";
import dotsIcon from "img/dotsIcon.svg";
import dropdownEmailIcon from "img/dropdownEmailIcon.svg";
import dropdownEdetailIcon from "img/dropdownEdetailIcon.svg";
import dropdownBannerIcon from "img/dropdownBannerIcon.svg";
import { routes } from "Uitls/Util";
import { useKeycloak } from "@react-keycloak/web";
import { Menu } from "@material-ui/core";
import LogoutDropdownCard from "components/LogoutDropdownCard";
import NotificationsSidebar from "components/dashboard/ModuleDashbaord/NotificationsSidebar";
import { getExpiryNotificationData, fetchAgenttype } from "services/apis";
import { showError, emitter } from "Uitls/Util";
import OverlayPopOver from "Uitls/OverlayPopOver";
import HomeIcon from "img/HomeIC.svg";
import { useHistory } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const DashboardHeader = ({ isGenai, disconnect, setIsDiffUser }) => {
  const { keycloak } = useKeycloak();
  const history = useHistory();
  const [value, setValue] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [unreadNotificationsCount, setUnreadNotificationsCount] =
    useState(undefined);
  const [expiryNotificationData, setExpiryNotificationData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [nonGenAIusers, setNonGenAIusers] = useState([]);
  useEffect(() => {
    getExpiryDataOfMCRT("");
  }, []);
  useEffect(() => {
    fetchAgentTypeData();
  }, []);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const getExpiryDataOfMCRT = (type) => {
    getExpiryNotificationData(type, (res, err) => {
      if (res) {
        let unreadCount = res?.data?.unReadCount;
        let expiryData = res?.data;
        setUnreadNotificationsCount(unreadCount);
        setExpiryNotificationData(expiryData);
        return;
      }
      showError(err);
    });
  };
  const fetchAgentTypeData = () => {
    const userInfo = getUserNameEmail();
    const userEmail = userInfo.userInfo.email;

    if (!userEmail) {
      console.warn("No email found for fetching agent type");
      return;
    }

    fetchAgenttype(userEmail, (response, err) => {
      if (err) {
        console.error("Failed to fetch agent type:", err);
        return;
      }

      if (response && response.data) {
        setNonGenAIusers(response.data);

        // Check agentType and set flag
        if (typeof setIsDiffUser === "function") {
          setIsDiffUser(response.data.agentType === "false");
        }
      }
    });
  };
  useEffect(() => {
    const handleFooEvent = (e) => {
      try {
        const parsedData = JSON.parse(e);
        if (parsedData.mlrStatus?.trim().toLowerCase().includes("expired")) {
          getExpiryDataOfMCRT("");
        }
      } catch (error) {
        console.error("Received non-JSON message:", e);
      }
    };

    emitter.on("autoSync", handleFooEvent);

    return () => {
      emitter.off("autoSync", handleFooEvent);
    };
  }, []);

  const getFirstLetters = () => {
    const userName = !!keycloak.authenticated
      ? keycloak.tokenParsed.name
      : null;
    if (!userName) return "";
    const nameArray = userName.split(" ");
    const firstLetters = nameArray.map((name) => name.charAt(0));
    return firstLetters.slice(0, 2).join("").toUpperCase();
  };

  const getUserNameEmail = () => {
    if (!keycloak.authenticated) {
      return { userInfo: { name: "", email: "" } };
    }
    const userInfo = keycloak.tokenParsed || {};
    return {
      userInfo: {
        name: userInfo.name || localStorage.getItem("currentUserName") || "",
        email: userInfo.email || localStorage.getItem("userEmail") || "",
      },
    };
  };
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      className="dashBoardIcon"
      title="NCCA Apps"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    ></div>
  ));

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar open/close state
  };

  const isMenuOpen = Boolean(anchorEl);
  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <ul className="list-unstyled appDropdown">
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value),
            )}
          </ul>
        </div>
      );
    },
  );

  return (
    <div>
      <div className="row dashboard-header align-items-center">
        <div className="col-md-4 px-20">
          <div className="d-flex">
            {!isGenai && (
              <a href="https://contentstudio.gilead.com">
                <div className="dashBoardIcon" title="NCCA Apps"></div>
              </a>
            )}
            {isGenai && (
              <div className="mt-1">
                <img
                  src={HomeIcon}
                  alt="Home"
                  onClick={() => {
                    disconnect();
                    setTimeout(() => {
                      history.push(routes.dashboard);
                    }, 100);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </div>
            )}
            <img src={nextIcon} alt="" className="img-fluid nextIcon" />
          </div>
        </div>
        <div className="col-md-4 px-20 d-flex justify-content-center align-items-center">
          {isGenai && <span className="genAiEdaText">Module Agent</span>}
        </div>
        <div className="col-md-4 px-20">
          <div className="d-flex justify-content-end align-items-center">
            <div>
              <span className="sourceText ">Source</span>
              <div className="promotext ">PromoMats</div>
            </div>
            <div className="ml16">
              <OverlayPopOverToolTip
                element={
                  <img
                    src={
                      unreadNotificationsCount > 0 ? NotifyIcon : NoNotifyIcon
                    }
                    alt=""
                    className="img-fluid bell-icon"
                    onClick={toggleSidebar}
                  />
                }
                overlayData={
                  <ToolTipText className="tooltip-text-Bell-icon">
                    Click to view notifications for expired Elements, Modules
                    and Materials in the last 30 days.
                  </ToolTipText>
                }
                trigger={["hover", "focus"]}
                placement="bottom"
                classId="tooltip"
              />
            </div>
            {/* <div>
              <Dropdown>
                <Dropdown.Toggle
                  className="userLogin"
                  id="userLogout"
                  drop="left"
                >
                  <div className="userName"> {getFirstLetters()}</div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <ul className="list-unstyled appDropdown">
                    <LogoutDropdownCard
                      getFirstLetters={getFirstLetters}
                      getUserNameEmail={getUserNameEmail()}
                    />
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                className="logoutToggleButton"
                title="Logout"
                onClick={handleMenuClick}
                aria-controls="logout-menu"
                aria-haspopup="true"
                aria-expanded={isMenuOpen ? "true" : undefined}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "4px",
                  padding: "0 3px",
                  border: "1px solid #203662",
                  borderRadius: "24px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  width: "52px",
                  height: "31px",
                  boxSizing: "border-box",
                  marginLeft: "12px",
                  outline: "none",
                  boxShadow: "none",
                  position: "relative",
                  flexShrink: 0,
                }}
              >
                <div
                  className="userName"
                  style={{
                    fontSize: "12px",
                    color: "#fff",
                    backgroundColor: "#203662",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    flexShrink: 0,
                    fontWeight: 600,
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {getFirstLetters()}
                </div>
                {isMenuOpen ? (
                  <ExpandLessIcon
                    className="logoutArrowIcon"
                    style={{
                      color: "#203662",
                      fontSize: "16px",
                      width: "16px",
                      height: "16px",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <ExpandMoreIcon
                    className="logoutArrowIcon"
                    style={{
                      color: "#203662",
                      fontSize: "16px",
                      width: "16px",
                      height: "16px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </div>
              <Menu
                id="logout-menu"
                anchorEl={anchorEl}
                keepMounted
                open={isMenuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                getContentAnchorEl={null}
                classes={{
                  paper: "logOutButtonMenu",
                  list: "logOutButtonMenuList",
                }}
                className="logOutButton"
                MenuListProps={{
                  disablePadding: true,
                  style: { padding: 0 },
                  className: "logOutButtonMenuList",
                }}
                PaperProps={{
                  className: "logOutButtonMenu",
                  style: {
                    marginTop: "4px",
                  },
                }}
              >
                <LogoutDropdownCard
                  getFirstLetters={getFirstLetters}
                  getUserNameEmail={getUserNameEmail()}
                />
              </Menu>
            </div>
          </div>
        </div>
      </div>
      {/* Notifications Sidebar */}
      {isSidebarOpen && (
        <NotificationsSidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          expiryNotificationData={expiryNotificationData}
          getExpiryDataOfMCRT={getExpiryDataOfMCRT}
        />
      )}
    </div>
  );
};

export default DashboardHeader;
